import React from 'react';
import {useIntl} from 'react-intl';
import Util from '../../../../shared/util/util';
import {StyledTime} from './checkmark_time_styled.js';

type TimeRegistrationDayTotalsProps = {
	billableMinutesRegistered: number;
	minutesRegistered: number;
};
function TimeRegistrationDayTotals({
	minutesRegistered,
	billableMinutesRegistered,
}: TimeRegistrationDayTotalsProps): JSX.Element {
	const intl = useIntl();
	const registeredTimeInHours = Util.convertMinutesToFullHour(minutesRegistered, intl, true);
	const billableRegisteredTimeInHours = Util.convertMinutesToFullHour(billableMinutesRegistered, intl, true);

	return (
		<StyledTime>
			{minutesRegistered ? (
				<div style={{display: 'flex', flexDirection: 'column', gap: '4px', flexGrow: 1, justifyContent: 'center'}}>
					<p style={{width: '100%', lineHeight: '14px'}}>{registeredTimeInHours}</p>
					<p style={{width: '100%', lineHeight: '14px', color: '#727483'}}>
						{billableMinutesRegistered !== minutesRegistered ? `${billableRegisteredTimeInHours} bil.` : ''}
					</p>
				</div>
			) : (
				''
			)}
		</StyledTime>
	);
}

export default TimeRegistrationDayTotals;
